import React from 'react';
import AKTooltip, { type TooltipProps } from '@atlaskit/tooltip';

export default function Tooltip(props: TooltipProps) {
	return <AKTooltip {...props} />;
}
